/**
 * Declaring the redux reducers and default state
 * for snb candidate page
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import EVENTS from '../../constants/events';

const defaultSnbLoadState = {
	'showSimilarJobsTupleOnSnB' : false
};

const SnbReducer = (state = defaultSnbLoadState, actions) => {
	switch (actions.type) {
		case EVENTS.UPDATE_JOB_LISTINGS :
			state.jobs = Object.assign({},state.jobs, actions.payload);
			break;
		case EVENTS.SNB_CONTAINER_EVENTS.RECEVED_SIMILAR_JOBS_AJAXDATA :
			state = Object.assign(state, { showSimilarJobsTupleOnSnB: actions.payload.showHide });
			return state;
			break;
		default:
			return state;
	}
};
export default SnbReducer;


// WEBPACK FOOTER //
// ../q-jobs/src/reducers/SnbReducer/index.js